import React, { useEffect } from "react";
import { connect, useIntl } from "umi";
import { Modal, Button, notification } from "tea-component";
import { deleteSelectorSchemeList } from "@/pages/dashboard/services/dashboardSetting";
import { storage } from "@/utils/utils";
import { DB_DASHBOARD_LOCAL_FILTER_SAVE_OUT_SCHEME_KEY, DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY } from "@/pages/dashboard/_config/constant";

import "@/pages/dashboard/assets/scss/components/deleteSetting.scss"

const DeleteSetting = (props: any) => {
    let { visible, gameCode, isOutScheme, selectorSchemeList, getOutSelectorSchemeList, close, setSelectedValue, selectedValue, deletedFilter } = props
    const { id, filter_name } = deletedFilter;
    const { formatMessage } = useIntl();

    useEffect(() => {
        // 当筛选器方案被删除完之后，删除方案的缓存，防止没方案的时候展示删除之前选中的方案
        // 实际上应该不存在这种情况，因为删除的时候会把当前选中的方案的缓存一起删掉，这样就能保证页面没有错误的缓存
        // 此处处理是为了兜底，担心有某种情况没考虑到
        if (selectorSchemeList?.length === 0) {
            storage.removeItem(isOutScheme ? DB_DASHBOARD_LOCAL_FILTER_SAVE_OUT_SCHEME_KEY : DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY)
        }
    }, [selectorSchemeList?.length])

    const deleteSelectorScheme = () => {
        deleteSelectorSchemeList(gameCode, id).then((result: any) => {
            notification.success({
                description: formatMessage({ id: 'filter_save_delete_success' }),
                className: 'filter-lock-alert',
                duration: 1000
            })
            //如果删除的方案就是选中的方案，则删除缓存
            if (id === selectedValue?.id) {
                storage.removeItem(isOutScheme ? DB_DASHBOARD_LOCAL_FILTER_SAVE_OUT_SCHEME_KEY : DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY)
            }

            // 筛选器方案下拉改为初始状态
            setSelectedValue({})
            // 请求游戏筛选器方案下拉框
            if (isOutScheme) {
                getOutSelectorSchemeList && getOutSelectorSchemeList()
            } else {
                props.dispatch({
                    type: "dashboardSetting/getSelectorSchemeList",
                    payload: {
                        gameCode
                    }
                });
            }
            close()
        }).catch((err: any) => {
            notification.error({
                description: formatMessage({ id: 'filter_save_delete_fail' }),
                className: 'filter-lock-alert',
                duration: 1000
            })
        })
    }


    return (
        <Modal visible={visible} caption='' onClose={close}>
            <Modal.Body>
                <div className="deleteSetting-title">{formatMessage({ id: 'filter_save_delete_setting' })}</div>
                <div className="deleteSetting-desc">{formatMessage({ id: 'filter_save_sure_to_delete' }, { name: <span className='dbd_filter_save_delete_name'>{filter_name}</span> })}</div>
            </Modal.Body>
            <Modal.Footer>
                <Button type="primary" onClick={deleteSelectorScheme}>
                    {formatMessage({ id: 'common_confirm' })}
                </Button>
                <Button type="weak" onClick={close}>
                    {formatMessage({ id: 'common_cancel' })}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default connect((state: any) => {
    const { dashboard } = state;
    return {
        gameCode: dashboard?.currentGame?.game_code || '',
    }
})(DeleteSetting);
